import { Component } from "./Component";
import { vp } from "../managers/vp";
export class ShareBar extends Component {
    constructor() {
        super(require("../../html/ShareBar.handlebars")());
    }
    init(videoModel) {
        this._videoModel = videoModel;
        this.initShare('facebook');
        this.initShare('twitter');
        this.initShare('whatsapp');
    }
    initShare(name) {
        const adapter = vp.shareManager.getAdapter(name, true);
        const button = this.getHtml(name);
        if (adapter) {
            button.style.display = 'inline-block';
            button.addEventListener('click', () => {
                adapter.share(this._videoModel.url, this._videoModel.title);
            });
            return true;
        }
        else {
            button.style.display = 'none';
            return false;
        }
    }
}
